@if (message) {
  <div id="modal-wrapper">
    <div class="modal-overflow" (click)="overflowClick($event)"></div>
    <div class="modal-popup">
      <div class="modal-desc">
        @if (message.icon !== 'popup-wait-animation') { <span class="modal-icon" [ngClass]="message.icon"></span> }
        @if (message.icon === 'popup-wait-animation') {
          <span class="popup-wait-animation">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </span>
        }
        <span class="modal-title">{{message.title}}</span>
        <span class="modal-text" [innerHTML]="message.desc"></span>
        @if (message.checkboxDesc) {
          <div class="modal-optional-checkbox">
            <label>
              <input type="checkbox" (click)="message.checkboxFn()">
              <span>{{ message.checkboxDesc }}</span>
            </label>
          </div>
        }
      </div>
      @if (message.buttons) {
        <div class="modal-btn-group">
          @if (message.buttons.left ) { <button class="popup-btn-custom" (click)="message.leftFn()" >{{ message.buttons.left  }}</button> }
          @if (message.buttons.right) { <button class="popup-btn-custom" (click)="message.rightFn()">{{ message.buttons.right }}</button> }
          @if (message.buttons.back ) { <button class="popup-btn-back"   (click)="message.backFn()" >{{ message.buttons.back  }}</button> }
          @if (message.buttons.no   ) { <button class="popup-btn-no"     (click)="message.noFn()"   >{{ message.buttons.no    }}</button> }
          @if (message.buttons.yes  ) { <button class="popup-btn-yes"    (click)="message.siFn()"   >{{ message.buttons.yes   }}</button> }
        </div>
      }
    </div>
  </div>
}
